import {
  exam_lists,
  getExam,
  exam_record
} from '@/api/exam'
const exam = {
  state: {},
  mutations: {

  },
  actions: {
    /**
     * 获取考试试卷
     * @param {*} context 
     * @param {*} data 
     */
    exam_lists({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        exam_lists(params).then(response => {
          const {
            data
          } = response;

          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取考试试卷
     * @param {*} context 
     * @param {*} data 
     */
    getExam({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          getExam(params).then(response => {
            const {
              data
            } = response;
  
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },
      /**
     * 交卷
     * @param {*} context 
     * @param {*} data 
     */
    exam_record({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          exam_record(params).then(response => {
            const {
              data
            } = response;
  
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      }

    

  }

}

export default exam



// WEBPACK FOOTER //
// ./src/store/modules/exam.js